/**
 * Preserves an existing workspace-level label only when there is one unambiguous
 * Business-group assignment. Labels must never be copied across groups.
 */
export const migrateLegacyConnectionLabel = ({
    legacyLabel,
    brandIds,
    existingLabels = {},
}: {
    legacyLabel?: string | null;
    brandIds: string[];
    existingLabels?: Record<string, string>;
}): Record<string, string> => {
    const normalizedLabel = legacyLabel?.trim() || '';
    if (!normalizedLabel || brandIds.length !== 1) {
        return existingLabels;
    }

    const [brandId] = brandIds;
    return existingLabels[brandId]
        ? existingLabels
        : { ...existingLabels, [brandId]: normalizedLabel };
};
